<!-- Header Start -->
<div class="modal-header border-0 position-relative">
  <button type="button" class="close mt-1" aria-label="Close mt-5" (click)="onCancelClick()">
    <span aria-hidden="true" class="font32px">×</span>
  </button>
  <h5 class="modal-title w-100 border-0 mt-5" id="myModalLabel">
    {{heading}}
  </h5>
</div>
<!-- Header ENDS -->
<!-- Body Start -->
<div class="modal-body pb-0 ">
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1 justify-content-center align-items-center">
      <ngb-carousel>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <!--<img [src]="swatchesImagesPath + selectedImage.imagePath + selectedImage.imageName" alt="Random second slide" />-->

            @if (!selectedImage.imageByte) {
              <img [src]="sanitize(swatchesImagesPath + selectedImage.imagePath + selectedImage.imageName)" alt="Random second slide" />
            }
            @if (selectedImage.imageByte) {
              <img (error)="onImgError($event)" [src]="'data:image/png;base64,' + selectedImage.imageByte" alt="Preview Image" class="img-fluid">
            }
          </div>
          @if (isShowImageName) {
            <div class="carousel-caption">
              <!--<h4>{{element.imageName}}</h4>-->
              <p>{{selectedImage.imageSource}}</p>
            </div>
          }
        </ng-template>

        @for (element of allImages; track element; let idx = $index) {
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
              @if (!element.imageByte) {
                <img [src]="sanitize(swatchesImagesPath + element.imagePath + element.imageName)" alt="Random second slide" />
              }
              @if (element.imageByte) {
                <img (error)="onImgError($event)" [src]="'data:image/png;base64,' + element.imageByte" alt="Preview Image" class="img-fluid">
              }
            </div>
            @if (isShowImageName) {
              <div class="carousel-caption">
                <!--<h4>{{element.imageName}}</h4>-->
                <p>{{element.imageSource}}</p>
              </div>
            }
          </ng-template>
        }
      </ngb-carousel>
    </div>
  </div>
</div>


